// extracted by mini-css-extract-plugin
export default {"description":"style_description__nHFRk","icon":"style_icon__8jaIx"};